export const breadcrumbMapArr = [
  {
    name: "PT+ Admin",
    link: "ptplus-user-managememt",
    eventType: "",
  },
];

export const headerArr = [
  { title: 'Customer Name' },
  { title: 'Location Name' },
  { title: 'Address' },
  { title: 'City' },
  { title: 'State' }
];

export const vendorListHeaderArr = [
  "Vendors",
  "Pallet Details",
  "Vendor Price",
  "Rate Type",
  "Start Date",
  "End Date",
  "Comment",
  "Actions",
  "Flat Fee",
]

export const listingRawData = [
  {
    "customerName": "123 Inc",
    "locationName": "Warehouse B",
    "city": "Chicago",
    "state": "New York",
    "feeItems": [
      {
        "vendorName": "PQR Distributors",
        "palletType": "Grade A",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      },
      {
        "vendorName": "Test",
        "palletType": "Grade B",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      }
    ]

  },
  {
    "customerName": "XYZ Corp",
    "locationName": "Distribution Center 1",
    "city": "Los Angeles",
    "state": "California",
    "feeItems": [
      {
        "vendorName": "LMN Logistics",
        "palletType": "Grade A",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      },
      {
        "vendorName": "LMN Testing",
        "palletType": "Grade B",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      }
    ]

  }
]

export const materialList = [
  { id: "0", label: "Wood", value: "wood", },
  { id: "1", label: "Plastic", value: "plastic", },
  { id: "2", label: "Other", value: "other", },
]

export const woodConditions = [
  { label: "Recycled", value: "recycled" },
  { label: "New", value: "newCondition" },
  { label: "Combo", value: "combo" },
];

export const plasticConditions = [
  { label: "Recycled", value: "recycled" },
  { label: "New", value: "newCondition" }
];

export const hardOrSoftWoodArray = [
  { label: "New - HW", value: "New - HW" },
  { label: "New - SW", value: "New - SW" },
];

export const newOrRecycledPalletList = [
  { label: "Block", value: "block" },
  { label: "Stringer", value: "stringer" },
  { label: "Euro Pallet", value: "euroPallet" },
  { label: "Crate", value: "crate" },
  { label: "Tray", value: "tray" },
  { label: "Other", value: "other" },
];

export const comboPalletList = [
  { label: "Stringer", value: "stringer" },
  { label: "Crate", value: "crate" },
  { label: "Custom", value: "custom" },
];

export const vendorPricingAddTableHeader = [
  'Buyback Vendor', 'Pallet Details', 'Vendor Price', 'Rate Type', 'Start Date', 'End Date', 'Actions'
]

export const flatFeeListingTableHeader = [
  'Flat Fee', 'Start Date', 'End Date'
]

